define("ember-cli-string-helpers/helpers/capitalize", ["exports", "@ember/component/helper", "@ember/string", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _string, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.capitalize = void 0;
  const capitalize = _exports.capitalize = (0, _createStringHelper.default)(_string.capitalize);
  var _default = _exports.default = (0, _helper.helper)(capitalize);
});